"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasChildSubList = void 0;

var react_1 = require("react");

var core_1 = require("@bodiless/core");

var uuid_1 = require("uuid");

var fclasses_1 = require("@bodiless/fclasses");

var lodash_1 = require("lodash");

var hasChildSubList = function hasChildSubList(context, count) {
  if (count === void 0) {
    count = 1;
  }

  var descendants = context.activeDescendants || []; // The first child list is the one to which this toggle applies,
  // so we check to see if more than one.

  return descendants.filter(function (c) {
    return c.type === 'list-item';
  }).length > count;
};

exports.hasChildSubList = hasChildSubList;

var useMenuOptions = function useMenuOptions(useOverrides) {
  if (useOverrides === void 0) {
    useOverrides = function useOverrides() {
      return {};
    };
  }

  return function (props) {
    var addItem = props.addItem,
        deleteItem = props.deleteItem,
        canDelete = props.canDelete; // Search for parent lists to set the default group label

    var context = core_1.useEditContext();
    var n = 0;

    for (var c = context; c; c = c.parent) {
      if (c.type === 'list-item') n += 1;
    }

    var sublistLabel = n > 1 ? "Sub-List " + n + " Item" : 'Sub-List Item';
    var defaultGroupLabel = n > 0 ? sublistLabel : 'List Item';

    var _a = useOverrides(props),
        _b = _a.groupLabel,
        groupLabel = _b === void 0 ? defaultGroupLabel : _b,
        _c = _a.global,
        global = _c === void 0 ? false : _c,
        _d = _a.local,
        local = _d === void 0 ? true : _d;

    var id = uuid_1.v1();
    var group = "list-item-group-" + id;
    var menuOptions = react_1.useMemo(function () {
      return [{
        name: "add-" + id,
        icon: 'add',
        label: 'Add',
        handler: addItem,
        global: global,
        local: local,
        group: group
      }, {
        name: "remove-" + id,
        icon: 'delete',
        label: 'Delete',
        isHidden: function isHidden() {
          return !canDelete();
        },
        handler: deleteItem,
        global: global,
        local: local,
        group: group
      }, {
        name: group,
        label: groupLabel,
        global: global,
        local: local,
        Component: 'group'
      }];
    }, []);
    return menuOptions;
  };
};
/**
 * HOC which adds list edit buttons (Add and Delete Item).
 */


var withListButtons = function withListButtons(useOverrides) {
  return core_1.ifEditable(fclasses_1.withFinalDesign({
    Item: lodash_1.flow(core_1.withContextActivator('onClick'), core_1.withLocalContextMenu, core_1.withMenuOptions({
      useMenuOptions: useMenuOptions(useOverrides),
      name: 'List Item',
      type: 'list-item'
    }))
  }));
};

exports.default = withListButtons;